import React, { ReactNode, useEffect } from "react"
import { CacheProvider } from "@emotion/react"
import createCache from "@emotion/cache"
import CssBaseline from "@mui/material/CssBaseline"
import { ThemeProvider as CustomThemeProvider } from "theme/ThemeContext"
import AOS from "aos"
import "aos/dist/aos.css"

import "./global.css"

const createEmotionCache = () => createCache({ key: "css", prepend: true })

interface WrapRootElementProps {
  element: ReactNode
}

const wrapRootElement = ({ element }: WrapRootElementProps): JSX.Element => {
  const cache = createEmotionCache()

  // AOS initialization and refresh logic
  // useEffect(() => {
  //   AOS.init({
  //     once: true,
  //     delay: 50,
  //     duration: 500,
  //     easing: "ease-in-out",
  //   })

  //   return () => {
  //     AOS.refresh() // Refresh AOS when necessary (e.g., on theme change)
  //   }
  // }, [])

  return (
    <CacheProvider value={cache}>
      <CustomThemeProvider>
        <CssBaseline />
        {/* Render the element (body component) passed into the provider */}
        {element}
      </CustomThemeProvider>
    </CacheProvider>
  )
}

export default wrapRootElement
